import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Customer } from "../models";
import { customerConfig } from "../selectors";
import * as SharedLoyaltyActions from "../actions/loyalty.actions"
import { SharedLoyaltyActionsTypes } from "../actions/loyalty.actions";
import { select, Store } from "@ngrx/store";
import { map, switchMap, withLatestFrom } from "rxjs/operators";
import { LoyaltySharedService } from "../../services/loyalty.service";

@Injectable()

export class sharedLoyaltyEffects {

  constructor(
    private actions$: Actions,
    private store: Store<any>,
    private loyaltyService: LoyaltySharedService
  ) { }

  initLoyaltyConfig$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SharedLoyaltyActionsTypes.InitSharedLoyaltyConfig),
      withLatestFrom(this.store.pipe(select(customerConfig))),
      switchMap(([action, customerConfigState]: [any, any]) => {

        const customerConfig: Customer = customerConfigState.customerConfig;

        return this.loyaltyService
          .initLoyaltyConfig(customerConfig.default_store_code).pipe(
            map(
              (loyaltyConfig: any) => {
                console.log('loyaltyConfig: ', loyaltyConfig);
                return new SharedLoyaltyActions.SetSharedLoyaltyConfig({
                  loyaltyConfig: {
                    enabled_for_market: loyaltyConfig.enabled_for_market,
                    enabled_for_account: customerConfig.loyalty_enabled_for_account
                  }
                })
              }
            )
          )
      }
      )
    )
  });


}
